// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__25hrV","buttons":"Table_buttons__24Niq","sortButtonContainer":"Table_sortButtonContainer__3KqKh","hideAllButtons":"Table_hideAllButtons__FEUdF"};